import { Component } from "@kluntje/core";
import { DebuggerService, LazyConnectService } from "@kluntje/services";

import styles from "./sde-e-icon.shadow.scss";

export class Icon extends Component {
  constructor() {
    super({
      initialStates: {
        loaded: false,
      },
      useShadowDOM: true,
    });
  }

  protected connectedCallback() {
    LazyConnectService.subscribe(this, () => super.connectedCallback());
  }

  public get iconId(): string {
    return this.getAttribute("icon-id") || "";
  }

  public set iconId(newIconId: string) {
    this.setAttribute("icon-id", newIconId);
  }

  private get iconSrc(): string {
    return this.getAttribute("icon-src") || "";
  }

  static get observedAttributes() {
    return ["icon-id"];
  }

  attributeChangedCallback(name: string, oldValue: any, newValue: any) {
    if (oldValue === newValue) return;
    if (this.state.loaded === true) this.loadIcon();
  }

  protected afterComponentRender(): void {
    if (!this.state.loaded) {
      this.loadIcon();
    }
  }

  private async loadIcon() {
    try {
      if (this.iconId === "" && this.iconSrc === "") throw new Error("iconId and iconSrc not defined");
      let iconMarkup = "";

      if (this.iconId !== "") {
        iconMarkup = await this.loadIconFromChunk();
      } else {
        iconMarkup = await this.loadIconFromSrc();
      }

      this.appendIconMarkup(iconMarkup);
      this.setState({ loaded: true });
    } catch (e) {
      DebuggerService.error("Icon:", e);
      this.remove();
    }
  }

  private async loadIconFromChunk() {
    const { iconLoader } = await import("./iconLoader");
    const icon = await iconLoader(this.iconId);
    return icon;
  }

  private async loadIconFromSrc() {
    const response = await fetch(this.iconSrc);
    if (!response.ok) throw new Error(response.statusText);

    const contentType = response.headers.get("content-type");
    if (contentType === null || !contentType.startsWith("image/svg+xml")) {
      throw Error("wrong response type from service");
    }

    const textResponse = await response.text();
    return textResponse;
  }

  private appendIconMarkup(iconMarkup: string) {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    this.getUiRoot().innerHTML = `<style>${styles}</style>${iconMarkup}`;
  }
}

customElements.define("sde-e-icon", Icon);
